export const fields = [
	'Name',
	'Surname',
	'Nickname',
	'Second Names',
	'Maiden Name',
	'Initials',
	'Full Name',
	'Email',
	'Title',
	'Gender',
	'SA ID',
	'Smoker',
	'Language',
	'Correspondence Type',
	'Cell number',
	'Phone number',
	'Date of birth',
	'Age',
	'Monthly Income',
	'Wedding date',
	'Marriage Status',
	'File no.',
	'Residential Address 1',
	'Residential Address 2',
	'Residential Address 3',
	'Residential Address 4',
	'Residential Postal Code',
	'Postal Address 1',
	'Postal Address 2',
	'Postal Address 3',
	'Postal Address 4',
	'Postal Address Code',
	'Bank Account Name',
	'Bank Name',
	'Branch Name',
	'Branch Code',
	'Account Type'
];

export const propertyMapping = {
	Name: 'scd_name',
	Surname: 'scd_surname',
	Nickname: 'scd_nickName',
	'Second Names': 'scd_secondAndOtherNames',
	'Maiden Name': 'scd_maidenName',
	Initials: 'scd_initials',
	'Full Name': 'full_name',
	Email: 'scd_email',
	Title: 'scd_title',
	Gender: 'scd_gender',
	'SA ID': 'scd_saID',
	Smoker: 'scd_smoker',
	Language: 'scd_correspondenceLanguage',
	'Correspondence Type': 'scd_correspondenceType',
	'Cell number': 'scd_cellNumber',
	'Phone number': 'scd_phoneNumber',
	'Date of birth': 'date_of_birth',
	Age: 'age',
	'Monthly Income': 'scd_monthlyIncome',
	'Wedding date': 'scd_weddingDate',
	'Marriage Status': 'scd_maritalStatus',
	'File no.': 'scd_clientFileNumber',
	'Residential Address 1': 'scd_residentialAddress',
	'Residential Address 2': 'scd_residentialAddress2',
	'Residential Address 3': 'scd_residentialAddress3',
	'Residential Address 4': 'scd_residentialAddress4',
	'Residential Postal Code': 'scd_postalCode',
	'Postal Address 1': 'scd_postalAddress1',
	'Postal Address 2': 'scd_postalAddress2',
	'Postal Address 3': 'scd_postalAddress3',
	'Postal Address 4': 'scd_postalAddress4',
	'Postal Address Code': 'scd_postalAddressCode',
	'Bank Account Name': 'sb_accountName',
	'Bank Name': 'sb_bank',
	'Branch Name': 'sb_branchName',
	'Branch Code': 'sb_branch',
	'Account Type': 'sb_accountType'
};


// WEBPACK FOOTER //
// ./src/views/Clients/components/advanced_search/objects.js